import { httpPostRequest } from "clients/phronesisClient"

export enum DynamicConfigs {
	AuthReleaseDay = "auth_release_day",
}

const DYNAMIC_CONFIG_ENDPOINT = "/dynamic-config"

export const getDynamicConfig = async (
	key: DynamicConfigs
): Promise<string> => {
	try {
		const response = await httpPostRequest(DYNAMIC_CONFIG_ENDPOINT, {
			key,
		})
		return response.value
	} catch (error) {
		return ""
	}
}
